import { api, apiMipe } from '@/core/api/';
import billingStatus from '@/utils/constants/billingStatus.js';

const billingHistoryApi = 'api/providerthrpybilling';

const tapRequestApi = 'api/taprequests';

export const getAcademicYears = async (minYear, maxYear) => {
  try {
    const { data } = await apiMipe.get('/api/academicyears');
    return data
      .filter((x) => x.id >= minYear && x.id <= maxYear)
      .map(({ id, description, selected }) => ({
        id,
        name: description,
        selected,
      }));
  } catch {
    return null;
  }
};
export const getBillingMonths = async (academicYearId) => {
  let { data } = await api
    .get(`${billingHistoryApi}/months/${academicYearId}`)
    .catch(() => {
      return [];
    });
  const mappedMonths = data.map((item) => {
    return {
      id: item.monthDesc,
      selected: false,
      disabled: false,
      isDirty: false,
      name: item.monthDesc,
      sortOrder: 0,
      monthNumber: item.monthNumber,
      year: item.year,
    };
  });
  return {
    months: data,
    mappedMonths,
  };
};
export const getBillingCenters = () => {
  return api.get(`${billingHistoryApi}/centers`);
};
export const getBillingProviders = (academicYearId) => {
  return api.get(`${billingHistoryApi}/providers/${academicYearId}`);
};
export const getBillingProvidersByServiceType = (
  academicYearId,
  serviceTypeId
) => {
  return api.get(
    `${billingHistoryApi}/providers/${academicYearId}/${serviceTypeId}`
  );
};
export const getBillingStatus = async (viewOnlyPreliminar = false) => {
  const { data } = await api.get(`${billingHistoryApi}/status`);
  if (!viewOnlyPreliminar) {
    return data.filter((x) => x.id != billingStatus.Preliminar);
  }
  return data;
};
export const getServiceTypes = () => {
  return api.get(`${billingHistoryApi}/servicetype`);
};

export const getInterventors = () => {
  return api.get(`${billingHistoryApi}/interventors`);
};

export const createBilling = (model) => {
  return api.post(`${billingHistoryApi}/create`, model);
};

export const updateBillTotals = (billId) => {
  return api.post(`${billingHistoryApi}/updatebilltotals/${billId}`);
};

export const getBillingDetails = (billId) => {
  return api.get(`${billingHistoryApi}/${billId}`);
};

export const searchBilling = (payload, serviceCenterIds) => {
  return api.get(`${billingHistoryApi}/search?${serviceCenterIds}`, {
    params: payload,
  });
};

export const getBillingServiceDetails = (payload) => {
  return api.get(`${billingHistoryApi}/billdetail`, {
    params: payload,
  });
};

export const getBillingDocuments = (billId) => {
  return api.get(`${billingHistoryApi}/documents/${billId}`);
};

export const getDocumentTypes = (billId) => {
  return api.get(`${billingHistoryApi}/documents/types/${billId}`);
};

export const deleteBillingDocument = (documentId) => {
  return api.delete(`${billingHistoryApi}/documents/${documentId}`);
};

export const uploadBillingDocument = (billId, documentTypeId, data) => {
  return api.post(
    `${billingHistoryApi}/documents/create/${billId}/${documentTypeId}`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

export const getVisitDetails = (payload) => {
  return api.get(`${billingHistoryApi}/getvisitdetails`, {
    params: payload,
  });
};

export const getVisitStudentInfo = (
  studentServiceId,
  academicYearId,
  serviceDate,
  admissionId
) => {
  return api.get(
    `${billingHistoryApi}/getstudentvisitinfo/${studentServiceId}`,
    {
      params: {
        academicYearId,
        serviceDate,
        admissionId,
      },
    }
  );
};

export const getAdditionalInfo = (type, id) => {
  return api.get(`${billingHistoryApi}/additionalInfo/${type}/${id}`);
};

export const getServiceProposalDocuments = (requestId) =>
  api.get(`${billingHistoryApi}/serviceproposaldocuments/${requestId}`);

export const getThrpyBillingAdjustments = (id) => {
  return api.get(`${billingHistoryApi}/getthrpybillingadjustments/${id}`);
};

export const deleteBillingAdjustment = (id) => {
  return api.delete(`${billingHistoryApi}/deletebillingadjustment/${id}`);
};

export const getBillingStatusTransition = (statusId, billId) => {
  return api.get(
    `${billingHistoryApi}/getbillingstatustransition/${statusId}/${billId}`
  );
};

export const updateBillingStatus = (payload) => {
  return api.put(`${billingHistoryApi}/billingstatus`, payload);
};

export const getBillingDetailServiceType = (billId) => {
  return api.get(`${billingHistoryApi}/detailservice/${billId}`);
};

export const getBillingDetailDiscipline = (billId, serviceTypeId) => {
  return api.get(
    `${billingHistoryApi}/detaildiscipline/${billId}/${serviceTypeId}`
  );
};

export const getBillingDetailSpecialist = (billId, disciplineTypeId) => {
  return api.get(
    `${billingHistoryApi}/detailspecialist/${billId}/${disciplineTypeId}`
  );
};

export const submitBillValidation = (billId, isAppoitmentCoordinated) => {
  const queryString =
    isAppoitmentCoordinated != undefined
      ? `?isAppoitmentCoordinated=${isAppoitmentCoordinated}`
      : '';
  return api.post(`${billingHistoryApi}/submitbill/${billId}${queryString}`);
};

export const getEvaluationDocument = (summaryId, peiAtServiceId = null) => {
  return api.get(
    `${billingHistoryApi}/detail/appointment/document/${summaryId}?peiAtServiceId=${peiAtServiceId}`
  );
};

export const getInterventionRevisionDocument = (summaryId, planId) => {
  return api.get(
    `${billingHistoryApi}/detail/plan/document/${summaryId}/${planId}`
  );
};

export const checkUncheckFlagServiceDetail = (payload) => {
  return api.post(
    `${billingHistoryApi}/checkuncheckflagservicedetail`,
    payload
  );
};

export const getBillingHistory = (billId) => {
  return api.get(`${billingHistoryApi}/billingtracking/${billId}`);
};

export const getBillingAdjustmentSummary = (billId) => {
  return api.get(`${billingHistoryApi}/adjustmentsummary/${billId}`);
};

export const getBillingAdjustmentList = (billId) => {
  return api.get(`${billingHistoryApi}/adjustmentlist/${billId}`);
};

export const getBillingAdjustmentDetails = (billId, payload) => {
  return api.get(`${billingHistoryApi}/adjustmentsdetails/${billId}`, {
    params: payload,
  });
};
export const _getPaymentTabInfo = (billId) =>
  api.get(`${billingHistoryApi}/payment/${billId}`);

export const _getAvailablePurchaseOrderNumbers = (companyId, fiscalYearId) =>
  api.get(
    `${billingHistoryApi}/payment/purchaseordernumbers/${companyId}/${fiscalYearId}`
  );
export const _saveBillingPurchaseOrderNumber = (model) =>
  api.post(`${billingHistoryApi}/payment/purchaseordernumbers/add`, model);
export const _deleteBillingPurchaseOrderNumber = (
  paymentId,
  purchaseOrderNumberId,
  lineNumber
) =>
  api.delete(
    `${billingHistoryApi}/payment/purchaseordernumbers/${paymentId}/${purchaseOrderNumberId}/${lineNumber}`
  );
export const _cancelPayment = (billId, paymentId, isPartial = true) =>
  api.delete(
    `${billingHistoryApi}/payment/${billId}/${paymentId}/${isPartial}`
  );

export const saveAdjustmentObjection = (payload) => {
  return api.post(`${billingHistoryApi}/saveobjection`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const _hasAdjustmentObjections = async ({ billId }) => {
  let { data } = await api.get(
    `${billingHistoryApi}/hasadjustmentobjections/${billId}`
  );
  return data;
};

export const removeBillingAdjustmentComment = (payload) => {
  return api.delete(
    `${billingHistoryApi}/removebillingadjustmentcomment/${payload}`
  );
};

export const updateBillingAdjustmentStatus = (
  visitBillingAdjustmentId,
  billingAdjustmentObjectionStatusId,
  payload
) => {
  return api.post(
    `${billingHistoryApi}/updatebillingadjustmentstatus/${visitBillingAdjustmentId}/${billingAdjustmentObjectionStatusId}`,
    payload
  );
};

//manual Adjustment
export const getBillingServiceAdjustments = ({ billId, id }) => {
  return api.get(`${billingHistoryApi}/${billId}/${id}/adjustments`);
};

export const getReasons = ({ billId, id, typeId }) => {
  return api.get(
    `${billingHistoryApi}/${billId}/adjustment/reasons/${id}/${typeId}`
  );
};

export const getVisitByService = ({ billId, id, typeId }) => {
  return api.get(
    `${billingHistoryApi}/${billId}/adjustment/visits/${id}/${typeId}`
  );
};
export const saveAdjustment = (payload) => {
  return api.post(`${billingHistoryApi}/adjustment/`, payload);
};
export const updatePendingFunds = (billId) => {
  return api.post(`${billingHistoryApi}/updatependingfunds/${billId}`);
};
export const getIsPendingFunds = (billId) => {
  return api.get(`${billingHistoryApi}/ispendingfunds/${billId}`);
};
export const getBulkDownload = (payload) => {
  return api.get(`${billingHistoryApi}/bulkdownload`, {
    params: payload,
    responseType: 'blob',
  });
};
export const getSifdePurchaseOrders = (companyId, billId) =>
  api.get(
    `${billingHistoryApi}/sifde/payment/purchaseorders/${companyId}/${billId}`
  );

export const getSifdePurchaseOrderNumbers = (poId, companyId, academicYearId) =>
  api.get(`${billingHistoryApi}/sifde/payment/purchaseordernumbers/${poId}`, {
    params: {
      companyId,
      academicYearId,
    },
  });

export const getDigitNumbers = (poid, billId = null) => {
  return api.get(
    `api/providerthrpybilling/purchaseordernumber/digitnumbers/${poid}`,
    billId != null && billId !== 0 ? { params: { billId } } : undefined
  );
};

export const getDebtDigitNumbers = (billId, hiringType) =>
  api.get('api/providerthrpybilling/purchaseordernumber/digitnumbers/debt', {
    params: { billId, hiringType },
  });

export const getCertificationDocumentTypes = () =>
  api.get(`api/providerregistryvisit/summarycertification/documenttypes/`);

export const getDocumentPayments = (paymentId) =>
  api.get(`${billingHistoryApi}/documentpayments/${paymentId}`);

export const uploadDocumentPayment = (
  billId,
  documentTypeId,
  paymentId,
  file
) =>
  api.post(
    `${billingHistoryApi}/documents/create/${billId}/${documentTypeId}/${paymentId}`,
    file,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
export const deleteDocumentPayment = (documentId) =>
  api.delete(`${billingHistoryApi}/documentpayments/${documentId}`);

export const resendDocumentPayment = (documentId) =>
  api.post(`${billingHistoryApi}/documentpayments/resend/${documentId}`);

export const getPurchaseOrdersByCompany = (companyId, billingPeriod) => {
  return api.get(`api/providers/contract/purchaseordernumbers/${companyId}`, {
    params: { billingPeriod },
  });
};
export const getEducationalServiceResume = async (billId) =>
  api.get(`${billingHistoryApi}/educationalserviceresume/${billId}`);

export const getEducationalServiceDetails = async (summaryId) =>
  api.get(`${billingHistoryApi}/educationalservicedetails/${summaryId}`);

export const updateEducationalServiceMonthlyCost = async (billId) =>
  api.put(`${billingHistoryApi}/updateeducationalservicemonthlycost/${billId}`);

export const updateEducationalService = async (educationalService) =>
  api.put(`${billingHistoryApi}/updateeducationalservice`, educationalService);

export const getEducationalServicesSummary = async (requestId) =>
  apiMipe.get(`${tapRequestApi}/servicessummary/${requestId}`);

export const uploadProposalContractDocument = async (form) =>
  apiMipe.put(`${tapRequestApi}/proposalcontractdocument`, form);

export const removeProposalContractDocument = async (documentId) =>
  apiMipe.delete(
    `${tapRequestApi}/removeproposalcontractdocument/${documentId}`
  );

export const getProposalContractDocuments = async (reqId) =>
  apiMipe.get(`${tapRequestApi}/proposalcontractdocuments/${reqId}`);

export const getProjectByCompany = (billId) => {
  return api.get(`api/providers/contract/projectnumbers/${billId}`);
};

export const getProjectNumbersByCompany = (billId) => {
  return api.get(`api/providerthrpybilling/projectnumbers/${billId}`);
};

export const updateProjectIdBulk = (payload) => {
  return api.put(`${billingHistoryApi}/purchaseordernumber/bulkedit`, payload);
};

export const createJournalTracking = async (payload) =>
  api.post(`${billingHistoryApi}/createjournaltracking`, payload);

export const getJournalTracking = async (billId, pageIndex, pageSize) =>
  api.get(`${billingHistoryApi}/journaltrackings/${billId}`, {
    params: {
      pageIndex,
      pageSize,
    },
  });

export const markDocumentDownloaded = (billId) => {
  return api.post(`${billingHistoryApi}/markdocumentdownloaded/${billId}`);
};

export const saveVoucherInfo = async (payload) =>
  api.put(`${billingHistoryApi}/voucher`, payload);

export const saveVoucherNumber = async (payload) =>
  api.put(`${billingHistoryApi}/voucher-number`, payload);

export const _saveBillingPurchaseOrderNumberDebt = (model) =>
  api.post(`${billingHistoryApi}/payment/purchaseordernumbers/add-debt`, model);
